<template>
  <v-row class="mx-0 bg-primary_dark" align="center" justify="center">
    <v-col cols="12" sm="12" md="10">
      <v-row
        :class="[$vuetify.breakpoint.mdAndUp ? 'px-10' : '']"
        class="mx-0"
        justify="center"
        align="center"
      >
        <v-col cols="12" sm="12" md="12">
          <h1 class="font-weight-bold my-5 white--text">Valores</h1>
          <v-row class="mx-0">
            <v-col cols="12" sm="6" md="6" lg="4" v-for="(item, index) in valores" :key="index">
              <v-card style="border-radius: 0.8rem;">
                <v-card-title class="d-flex justify-center align-center">
                  <v-icon style="font-size:4rem;" color="primary_dark">{{ item.icon }}</v-icon>
                </v-card-title>
                <v-card-text class="text-center pt-3">
                  <h3>{{ item.text }}</h3>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<style scoped>
.pt-header {
  padding-top: 120px;
}
.container {
  padding-left: 20%;
  padding-right: 20%;
}
</style>
<script>
export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    focusable: true,
    panel: [0, 1, 2],

    valores: [
      { text: "Liderazgo", icon: "mdi-human-greeting" },
      { text: "Honestidad", icon: "mdi-hand-heart" },
      { text: "Compromiso", icon: "mdi-charity" },
      { text: "Trabajo en Equipo.", icon: "mdi-account-multiple" },
      { text: "Servicio al Cliente", icon: "mdi-headset" },
      { text: "Desarrollo Integral", icon: "mdi mdi-human-male-female" }
    ]
  })
};
</script>
